import { render, staticRenderFns } from "./RemnantList.vue?vue&type=template&id=d0762bae"
import script from "./RemnantList.vue?vue&type=script&lang=js"
export * from "./RemnantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports